/**
 * Frontend permission helpers.
 *
 * Centralised so we only have one place to maintain the admin allowlist.
 * These are **UI gates only** — the backend does not currently enforce
 * the same allowlist on the corresponding endpoints. Treat this as a
 * "don't show analysts the destructive controls" guardrail, not a
 * security boundary.
 *
 * To promote someone to admin: add their email (lowercased) here.
 */

import { useAuthStore } from './authStore';

/**
 * Allow-list of admin email addresses. Matched case-insensitively against
 * the Firebase user's email. Keep this list short — every entry is a
 * person who can wipe data and edit system-wide settings.
 */
const ADMIN_EMAILS: readonly string[] = [
  'adamian2@gmail.com',
  'adamian@solverminds.com',
  'sathya.r@solverminds.com',
];

const ADMIN_EMAIL_SET = new Set(ADMIN_EMAILS.map((e) => e.toLowerCase()));

/** Returns true if the current Firebase user's email is in {@link ADMIN_EMAILS}. */
export function useIsAdmin(): boolean {
  const email = useAuthStore((s) => s.user?.email ?? null);
  if (!email) return false;
  return ADMIN_EMAIL_SET.has(email.toLowerCase());
}
